
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { getMainPhotoUrl } from "@/utils/photoUtils";
import { EventAttendee } from "@/services/eventService";

interface ParticipantsListProps {
  attendees?: (EventAttendee & {
    user: {
      username: string;
      email: string;
    };
  })[];
}

// Mock data for demonstration since we don't have complete user profile data in attendees
const getMockParticipantData = (username: string) => ({
  age: Math.floor(Math.random() * 20) + 25, // Random age between 25-44
  height: Math.floor(Math.random() * 30) + 160, // Random height between 160-190cm
  weight: Math.floor(Math.random() * 40) + 55, // Random weight between 55-95kg
  hashtags: ["fitness", "music", "travel", "foodie", "art", "tech"].slice(0, Math.floor(Math.random() * 4) + 2),
  profilePhoto: "/placeholder.svg"
});

const ParticipantsList = ({ attendees = [] }: ParticipantsListProps) => {
  if (attendees.length === 0) {
    return (
      <div className="text-sm text-gray-500">
        No participants yet
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">Participants ({attendees.length})</h4>
      <div className="grid gap-3">
        {attendees.map((attendee) => {
          const mockData = getMockParticipantData(attendee.user.username);
          
          return (
            <div key={attendee.id} className="flex items-center justify-between p-3 bg-blue-100 rounded-lg">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h5 className="font-semibold text-gray-900">{attendee.user.username}</h5>
                  <span className="text-sm text-gray-600">
                    {mockData.age}, {mockData.height}, {mockData.weight}
                  </span>
                </div>
                
                <div className="flex flex-wrap gap-1">
                  {mockData.hashtags.map((hashtag, index) => (
                    <span key={index} className="text-xs text-gray-700">
                      {hashtag}{index < mockData.hashtags.length - 1 ? ', ' : ''}
                    </span>
                  ))}
                </div>
              </div>
              
              <div className="ml-4">
                <Avatar className="w-12 h-12">
                  <AvatarImage src={mockData.profilePhoto} alt={attendee.user.username} />
                  <AvatarFallback className="bg-yellow-500 text-white">
                    {attendee.user.username.charAt(0).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ParticipantsList;
